import gsap from 'gsap';
import { fetchSwiper } from '../dynamic-modules';
import { videoLazyload } from './lazy-load';
import popups from './popups';

const storiesElements = Array.from(document.querySelectorAll('.js-stories'));
const autoplayDuration = 5000;

function animateTimeline(el) {
    return gsap.fromTo(
        el,
        { scaleX: 0 },
        {
            duration: autoplayDuration / 1000,
            scaleX: 1,
            ease: 'none',
        },
    );
}

function generateYoutubeEmbedURL(id) {
    const query = '?rel=0&showinfo=0&autoplay=1';
    return `https://www.youtube.com/embed/${id}${query}`;
}

function createIframe(id) {
    const iframe = document.createElement('iframe');
    iframe.className = 'responsive__item';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('src', generateYoutubeEmbedURL(id));
    return iframe;
}

const popup = popups.getInstanceByElement(document.querySelector('[data-lit-popup="story-inner"]'));
const iframeContainer = document.querySelector('.js-story-inner-content');

storiesElements.forEach(async (container) => {
    const slides = Array.from(container.querySelectorAll('.swiper-slide'));
    let tween;
    let swiper;

    if (slides.length > 1) {
        const { default: Swiper, Autoplay, Pagination, EffectFade, Lazy } = await fetchSwiper();
        Swiper.use(Autoplay);
        Swiper.use(Pagination);
        Swiper.use(EffectFade);
        Swiper.use(Lazy);

        let timelines = [];
        let prevTimeline;
        let currentTimeline;

        swiper = new Swiper(container, {
            effect: 'fade',
            grabCursor: true,
            loop: true,
            speed: 1000,
            edgeSwipeThreshold: 60,
            touchEventsTarget: 'wrapper',
            noSwipingSelector: '.swiper--no-swiping',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: autoplayDuration,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: (index, className) => `
                    <button class="stories-nav-item ${className}">
                        <span class="stories-nav-item__timeline"></span>
                    </button>
                `,
            },
            lazy: {
                loadPrevNext: true,
            },
            on: {
                afterInit(instance) {
                    timelines = Array.from(container.querySelectorAll('.stories-nav-item__timeline'));
                    currentTimeline = timelines[instance.realIndex];
                    tween = animateTimeline(currentTimeline);
                },
            },
        });

        let forceFinishTimeline;

        swiper.on('slideChange', (instance) => {
            forceFinishTimeline?.totalProgress(1).kill();
            gsap.set(prevTimeline, { scaleX: 0, overwrite: true });
            prevTimeline = currentTimeline;
            currentTimeline = timelines[instance.realIndex];
            forceFinishTimeline = gsap.to(prevTimeline, { duration: 0.15, scaleX: 1, overwrite: true });
        });

        swiper.on('slideChangeTransitionEnd', () => {
            setTimeout(() => {
                forceFinishTimeline?.totalProgress(1).kill();
                gsap.set(prevTimeline, { scaleX: 0, overwrite: true });
                tween = animateTimeline(currentTimeline);
            }, 1);
        });

        slides.forEach((el) => {
            const videoEl = el.querySelector('.js-inline-video');
            const initialTextEl = el.querySelector('.js-story__text');
            const textEl = popup.el.querySelector('.js-story-inner-title');

            if (videoEl) {
                videoEl.addEventListener('click', (event) => {
                    event.preventDefault();
                    const { videoId } = videoEl.dataset;

                    if (videoId) {
                        const iframe = createIframe(videoId);

                        if (iframeContainer) {
                            iframeContainer.appendChild(iframe);
                        }
                    }

                    if (initialTextEl && textEl) {
                        textEl.textContent = initialTextEl.textContent;
                    }

                    swiper.autoplay.stop();
                    tween?.pause();
                });
            }
        });

        videoLazyload.update();
    }

    if (popup) {
        popup.on('close-complete', () => {
            setTimeout(() => {
                if (iframeContainer) {
                    iframeContainer.innerHTML = '';
                    swiper.autoplay.start();
                    tween?.play();
                }
            }, 300);
        });
    }
});
